/* PiHOT support pages — sections/pihot-support-hero.liquid, pihot-faq.liquid
   - [data-p-open-chat] opens the Shopify Inbox window. Links keep their href as the
     fallback when Inbox has not loaded or is not installed.
   - Theme editor: selecting a FAQ question block opens it. */

(() => {
  if (window.PiHOT?.support) return;
  window.PiHOT = window.PiHOT || {};
  window.PiHOT.support = true;

  /* Inbox renders inside nested open shadow roots; its runtime element opens the
     panel, a synthetic click on the launcher button does not. */
  const findChatRuntime = (root = document) => {
    for (const host of root.querySelectorAll('shopify-chat, shopify-agent-runtime')) {
      if (typeof host.openFromActivator === 'function') return host;
      const runtime = host.shadowRoot && findChatRuntime(host.shadowRoot);
      if (runtime) return runtime;
    }
    return null;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-p-open-chat]');
    if (!trigger) return;
    const runtime = findChatRuntime();
    if (!runtime) return;
    event.preventDefault();
    runtime.openFromActivator();
  });

  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest?.('.p-faq__item') || event.target.querySelector?.('.p-faq__item');
    if (item) item.open = true;
  });
})();
